<!--
 * @Descripttion: ''
 * @Author: lilong(lilong@hztianque.com)
 * @Date: 2020-07-16 17:59:27
 * @LastEditTime: 2020-07-27 10:29:13
-->
<template>
  <div class="fz-container">
    <div class="navbar">
      <div class="navbar-system-name">法制日报政法展</div>
      <div class="navbar-content">
        <Menu
          mode="horizontal"
          theme="dark"
          :active-name="currentSelectMenu"
          ref="menus">
          <MenuItem
            :name="item.url"
            :to="item.url"
            v-for="(item,index) in menuList"
            :key="index">
            {{item.label}}
            </MenuItem>
        </Menu>
      </div>
      <div class="navbar-toolbar">
        <div class="toolbar">
          <Dropdown trigger="click" style="margin: 20px 0px 0px 20px;" @on-click="handleQuit">
              <a href="javascript:void(0)" class="aSpancolor">
                  <!--                  <Icon type="ios-contact-outline headerImg" />-->
                  {{userInfo.userName}}
                  <Icon type="ios-arrow-down"></Icon>
              </a>
              <DropdownMenu slot="list">
                  <DropdownItem>退出</DropdownItem>
              </DropdownMenu>
          </Dropdown>
          <!-- <ul>
            <li v-for="(item,index) in toolbarList" :key="index" class="username">
              <Dropdown trigger="click" style="margin-left: 20px">
                <img :src="item.imgUrl" alt>
                <span>{{userInfo.userName.length>1?userInfo.userName.substr(0,1):userInfo.userName}}</span>
                <span>{{userInfo.userName}}</span>
                <DropdownMenu slot="list">
                  <DropdownItem
                    v-for="(items,index) in item.dropdownMenu"
                    :key="index"
                    @click.native="buttonMethods(items.clickName)">
                    {{items.name}}
                    </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </li>
            <li class="username">
              <span>{{userInfo.userName.length>1?userInfo.userName.substr(0,1):userInfo.userName}}</span>
              <span>{{userInfo.userName}}</span>
            </li>
          </ul> -->
        </div>
      </div>
    </div>
    <div class="container">
      <div class="bread-crumd">
        <bread-crumb :list="breadCrumbList"></bread-crumb>
      </div>
      <div class="menu-content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { menuList } from '@/utilsData/menuList.js'
export default {
  name: 'Navbar',
  data() {
    return {
      currentSelectMenu: '', //当亲选中的菜单栏
      //导航栏右侧工具
      toolbarList: [
        {
          id: 1,
          imgUrl: require('@/assets/img/icon1.png'),
          dropdownMenu: [
            {
              name: '退出',
              clickName: 'quit',
            },
          ],
        },
        // {
        //   id: 2,
        //   imgUrl: require('@/assets/img/icon2.png'),
        //   dropdownMenu: [],
        // },
        // {
        //   id: 3,
        //   imgUrl: require('@/assets/img/icon3.png'),
        //   dropdownMenu: [],
        // },
        // {
        //   id: 4,
        //   imgUrl: require('@/assets/img/icon4.png'),
        //   dropdownMenu: [],
        // },
        // {
        //   id: 5,
        //   imgUrl: require('@/assets/img/icon5.png'),
        //   dropdownMenu: [],
        // },
      ],
      //登录用户名
      userInfo: {
        userName: this.$store.getters['globe/user/userName'],
      },
      //菜单导航栏
      menuList: menuList,
      breadCrumbList: [], //面包屑
    }
  },
  watch: {
    $route: {
      handler(route) {
        this.currentSelectMenu = route.path
        this.$nextTick(() => {
          this.$refs.menus.updateOpened()
          this.$refs.menus.updateActiveName()
        })
        this.breadCrumbList = []
        route.matched.forEach((item) => {
          this.breadCrumbList.push({
            title: item.meta.title,
            path: item.path,
          })
        })
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    //实现动态函数名触发函数
    buttonMethods(funcName) {
      const { methods } = this.$options
      methods[funcName]()
    },
    more() {
      console.log(1)
    },
    handleQuit() {
      localStorage.clear()
      this.$cookies.remove('sid')
      this.$router.push({
        path: '/login',
      })
      this.$destroy()
    },
  },
}
</script>

<style lang='scss' scoped>
.fz-container{
  width:100%;
  height:100%;
  background: cyan;
}
.navbar {
  width: 100%;
  height: 64px;
  background: #515a6e;
  display: flex;
  align-items: center;
  padding: 0 20px;
  .navbar-system-name {
    width: max-content;
    font-size: 24px;
    font-family: PingFangSC, PingFangSC-Semibold;
    font-weight: bolder;
    color: #ffffff;
    letter-spacing: 5px;
  }
  .navbar-content {
    flex: 1;
    height: 100%;
    line-height: 64px;
    padding: 0 45px;
    display: flex;
    align-items: center;
    /deep/.ivu-menu-horizontal {
      height: 50px;
      line-height: 50px;
    }
    /deep/.ivu-menu-item {
      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Medium;
      text-align: center;
      letter-spacing: 2px;
      color: rgba(255, 255, 255, 0.8);
    }
    /deep/.ivu-menu-item-selected {
      border-bottom: 3px solid #fff;
      font-weight: bold;
      color: #fff;
    }
    /deep/.ivu-menu-horizontal .ivu-menu-item,
    /deep/.ivu-menu-horizontal .ivu-menu-submenu {
      padding: 0 10px;
      margin-left: 35px;
    }
  }
  .navbar-toolbar {
    height: 100%;
    .toolbar {
      height: 100%;
      cursor: pointer;
      .aSpancolor{
        color: #fff;
      }
      > ul {
        display: flex;
        height: 100%;
        align-items: center;
        > li {
          display: flex;
          align-items: center;
          height: 100%;
        }
        li.username {
          span {
            font-size: 12px;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            text-align: left;
            color: #ffffff;
            &:first-of-type {
              display: inline-block;
              width: 24px;
              height: 24px;
              background: #2d8cf0;
              border-radius: 50%;
              text-align: center;
              line-height: 24px;
              margin-right: 10px;
            }
            &:last-of-type {
              letter-spacing: 2px;
            }
          }
        }
        /deep/.ivu-dropdown,
        /deep/.ivu-dropdown-rel {
          display: flex;
          align-items: center;
          // margin-bottom:10px;
          // height: 100%;
        }
        /deep/.ivu-dropdown {
          margin-left: 0px !important;
          margin-right: 30px;
        }
        /deep/.ivu-dropdown-item {
          text-align: center;
          height: 40px;
          line-height: 40px;
          padding: 0px;
        }
        /deep/.ivu-select-dropdown {
          position: relative;
          top:50px!important;
          &:before {
            content: "";
            width: 8px;
            height: 8px;
            background: #fff;
            position: absolute;
            top: -4px;
            left: 50%;
            transform: translateX(-50%) rotate(45deg);
          }
        }
      }
    }
  }
}
.container{
  background: #F8F8F8;
  width:100%;
  height:calc(100% - 64px);
  padding:0 30px;
  padding-bottom:30px;
  .bread-crumd{
    width:100%;
    height:40px;
    background-attachment: cyan;
    line-height: 40px;
  }
  .menu-content{
     box-sizing: border-box;
     height:calc(100% - 40px);
     background: #fff;
     border-radius: 4px;
  }
}
</style>